import * as z from 'zod';
export const PingSchema = z.strictObject({ ping: z.int() });
export const UserSchema = z.object({ userId: z.string() });
//# sourceMappingURL=misc.js.map